const fadeTime = 300;

const fadeOut = (target) => {
	target.style.opacity = 1;
	target.style.translate = 0;
	target.style.transition = `all ${fadeTime}ms`;
	target.style.opacity = 0;
	target.style.translate = "0 10px";

	setTimeout(() => {
		target.style.display = "none";
	}, fadeTime);
};

const fadeIn = (target) => {
	target.style.opacity = 0;
	target.style.translate = "0 10px";
	target.style.transition = `all ${fadeTime}ms`;
	target.style.opacity = 1;
	target.style.translate = 0;

	setTimeout(() => {
		target.style.display = "block";
	}, fadeTime);
};

const setActive = (el) => {
	[...el.parentElement.children].forEach((sib) => sib.classList.remove("is-active"));
	el.classList.add("is-active");
};

const setCSSVar = (name, value, target = "body") => {
	const element = target === "html" ? document.documentElement : document.body;
	element.style.setProperty(name, value);
};

const isInViewport = (element) => {
	var rect = element.getBoundingClientRect();
	var html = document.documentElement;
	return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || html.clientHeight) && rect.right <= (window.innerWidth || html.clientWidth);
};

const debounce = (fn, wait) => {
	let timeout;
	return function (...args) {
		clearTimeout(timeout);
		timeout = setTimeout(() => fn.apply(this, args), wait);
	};
};

const throttle = (fn, limit) => {
	let waiting = false;
	return function (...args) {
		if (!waiting) {
			fn.apply(this, args);
			waiting = true;
			setTimeout(() => {
				waiting = false;
			}, limit);
		}
	};
};

const getContainerPosLeft = (selector = ".wrapper") => {
	const main = document.querySelector(".main");

	let containers = [];

	// 1. Cherche les wrappers dans .main
	if (main) {
		containers = Array.from(main.querySelectorAll(selector));
	}

	// 2. Filtrage : on exclut les hero et wrapper--sm
	let container = containers.find((el) => !el.classList.contains("hero") && !el.classList.contains("wrapper--sm"));

	// 3. Fallback sur header__inner si aucun container valide trouvé
	if (!container) {
		const headerInner = document.querySelector(".header__inner");
		if (headerInner) {
			container = headerInner;
		} else {
			// Pas de container du tout, on retourne undefined
			return;
		}
	}

	// 4. Calcul position + gutter
	const rect = container.getBoundingClientRect();
	const style = getComputedStyle(container);
	const gutter = parseFloat(style.paddingInlineStart) || 0;

	setCSSVar("--_offset-x-start", `${rect.left}px`);
	if (gutter > 0) {
		setCSSVar("--_gutter", `${gutter}px`);
	}

	return rect.left + gutter;
};

// Fonction pour mettre à jour les variables de mise en page
const updateLayoutVars = () => {
	getContainerPosLeft();
};

// Fonction pour convertir une couleur HEX en HSL
// Exemple d'utilisation : hexToHSL('#ff5733') → { h: 9, s: 100, l: 50 }
const hexToHSL = (hex) => {
	hex = hex.replace("#", "");

	// Format court (#abc → #aabbcc)
	if (hex.length === 3) {
		hex = hex
			.split("")
			.map((c) => c + c)
			.join("");
	}

	const r = parseInt(hex.substring(0, 2), 16) / 255;
	const g = parseInt(hex.substring(2, 4), 16) / 255;
	const b = parseInt(hex.substring(4, 6), 16) / 255;

	const max = Math.max(r, g, b);
	const min = Math.min(r, g, b);
	let h, s, l;
	l = (max + min) / 2;

	if (max === min) {
		h = s = 0; // achromatic
	} else {
		const d = max - min;
		s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

		switch (max) {
			case r:
				h = ((g - b) / d + (g < b ? 6 : 0)) * 60;
				break;
			case g:
				h = ((b - r) / d + 2) * 60;
				break;
			case b:
				h = ((r - g) / d + 4) * 60;
				break;
		}
	}

	return {
		h: Math.round(h),
		s: Math.round(s * 100),
		l: Math.round(l * 100),
	};
};

// Fonction pour obtenir la valeur HSL d'une variable CSS
// Exemple d'utilisation : const color_hsl = getCSSVarHSL("--color");
// document.body.style.setProperty("--color-hs", `${color.h}, ${color.s}%`);
const getCSSVarHSL = (varName, element = document.body) => {
	const hexColor = getComputedStyle(element).getPropertyValue(varName).trim();
	if (!hexColor.startsWith("#")) {
		console.warn(`La variable ${varName} ne semble pas contenir une couleur HEX valide.`);
		return null;
	}

	return hexToHSL(hexColor);
};

// Utility: calculate perceived brightness (0 = black, 255 = white)
const getBrightness = (rgb) => {
	const match = rgb.match(/\d+/g);
	if (!match) return 255;
	const [r, g, b] = match.map(Number);
	return (r * 299 + g * 587 + b * 114) / 1000;
};

export { fadeOut, fadeIn, fadeTime, setActive, setCSSVar, getCSSVarHSL, isInViewport, debounce, throttle, getContainerPosLeft, updateLayoutVars, getBrightness };
